export default defineNuxtPlugin(() => {
  const img = document.createElement('img');
  img.src =
    'https://tracker.metricool.com/c3po.jpg?hash=5d07f776815b0b56f4a23419bd0301c0';
  img.alt = 'Image';
  img.style.display = 'none';
  document.body.appendChild(img);
});
